import { useFormContext } from 'react-hook-form';

export const useSubFormIsValidSync = schema => {
  const { watch } = useFormContext();

  const subFormFields = Object.keys(schema.fields);
  const subFormState = watch(subFormFields).reduce((acc, cur, i) => {
    acc[subFormFields[i]] = cur;
    return acc;
  }, {});

  return schema.isValidSync(subFormState);
};
